import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, useLocation } from 'react-router-dom';
import Dashboard from 'components/Dashboard';
import { dataHubUsers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';

const DataHubRedirect = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth0();

  if (isAuthenticated) {
    if (!user?.email) {
      return <Dashboard />;
    }
    if (!dataHubUsers(user.email)) {
      const newPath = location.pathname.replace('/data-hub', '/analytics');
      const search = location.search;
      return <Navigate replace to={`${newPath}${search}`} />;
    }
  }

  return <Dashboard />;
};

export default DataHubRedirect;
